import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { saveAdminSession, superadminLogin } from "./adminApi";
import "./LoginPage.css";

// Port of superadmin.php: password gate, then themes management on the global (superadmin) themes.
export default function SuperAdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const res = await superadminLogin(password);
      saveAdminSession({ sessionId: res.sessionId, organizationId: res.organizationId });
      navigate("/admin/themes", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="LoginPage_container">
      <form className="LoginPage_form" onSubmit={submit}>
        <h2 className="LoginPage_title">Superadmin Login</h2>
        {error && <div className="LoginPage_error">{error}</div>}

        <div className="LoginPage_field">
          <label className="LoginPage_label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            className="LoginPage_input"
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoFocus
          />
        </div>

        <button type="submit" className="LoginPage_button" disabled={busy}>
          {busy ? "Checking..." : "Login"}
        </button>
      </form>
    </div>
  );
}
